<template>
  <el-container class="fullheight" style="border: 1px solid #eee">
    <!-- <eco-menu-manager ref="ecoMenuManager" @node-click="handleNodeClick" hide-menu /> -->
    <el-container>
      <el-main>
        <eco-table
          @load="loadData"
          :data="data"
          :pageResult="pagination"
          :selection="true"
          :default-sorter="[{ direction: 'DESC', property: 'id' }]"
          quick-search-props="name,requestUrl"
          ref="ecoTable"
          :show-export="false"
        >
          <template v-slot:toolbar>
            <el-button-group>
              <el-button size="small" @click="showDialog()" type="primary">添加</el-button>
              &nbsp;
            </el-button-group>
          </template>
          <template>
            <eco-table-column type="index" width="50" align="center" label="序号" />
            <eco-table-column prop="id" label="主键" :sortable="true" hidden />
            <eco-table-column prop="name" label="名称" :sortable="true" :show-overflow-tooltip="true" />
            <eco-table-column prop="alias" label="别名" :sortable="true" />
            <eco-table-column prop="actionType" label="请求方法名" :sortable="true" />
            <eco-table-column prop="requestUrl" label="接口地址" :sortable="true" />
            <eco-table-column label="操作" fixed="right">
              <template v-slot="{ row }">
                <el-link @click="showDialog(row.id)" type="primary" :underline="false">编辑</el-link>
                <el-link @click="remove(row.id)" type="primary" :underline="false" class="marginLeft16">删除</el-link>
              </template>
            </eco-table-column>
          </template>
        </eco-table>
        <el-dialog title="添加接口" :visible="dialogVisible" width="500px" :before-close="beforeClose" :close-on-click-modal="false" append-to-body>
          <el-form v-form :model="api" data-vv-scope="apiList">
            <eco-form-item label="名称" labelWidth="90px">
              <eco-input v-model="api.name" style="width: 100%"></eco-input>
            </eco-form-item>
            <eco-form-item label="别名" labelWidth="90px">
              <eco-input v-model="api.alias" style="width: 100%"></eco-input>
            </eco-form-item>
            <eco-form-item label="请求方法名" labelWidth="90px">
              <eco-select
                style="width: 100%"
                v-model="api.actionType"
                :placeholder="`请选择请求方法名`"
                :options="[
                  { value: 'POST', key: 'POST' },
                  { value: 'PUT', key: 'PUT' },
                  { value: 'GET', key: 'GET' },
                  { value: 'DELETE', key: 'DELETE' }
                ]"
              ></eco-select>
            </eco-form-item>
            <eco-form-item label="接口地址" labelWidth="90px">
              <eco-input v-model="api.requestUrl" style="width: 100%"></eco-input>
            </eco-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="save()" type="primary">{{ $t('eip.common.save') }}</el-button>
            <el-button @click="close()">{{ $t('eip.common.cancel') }}</el-button>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import portalApi from '@/api/portal.js'
import req from '@/request.js'
const EcoMenuManager = () => import('@/components/system/FeMenuManager.vue')
const EipSysTypeSelector = () => import('@/components/selector/EipSysTypeSelector.vue')
export default {
  name: 'MenuManager',
  components: {
    EcoMenuManager,
    EipSysTypeSelector
  },
  data() {
    return {
      dialogVisible: false,
      editMenuFormVisible: false,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      api: {
        actionType: '',
        alias: '',
        name: '',
        requestUrl: ''
      },
      data: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      pathQuery: null
    }
  },
  watch: {},
  mounted() {},
  methods: {
    remove(id) {
      let _this = this
      portalApi.deleteAction(id).then((rep) => {
        if (rep && rep.state) {
          _this.$message({ type: 'success', message: rep.message })
          _this.close()
        } else {
          _this.$message.error(rep.message)
        }
      })
    },
    showDialog(id) {
      this.dialogVisible = true
      let _this = this
      portalApi.getActionDetail(id).then((rep) => {
        if (rep) {
          _this.api = rep
        } else {
          _this.$message.error(rep.message)
        }
      })
    },
    handleNodeClick(nodedata) {
      // 根据组织获取下级组织
      // 获取当前组织及下级组织
      let queryFilter = {
        pageBean: this.pagination,
        querys: []
      }
      this.pathQuery = {
        property: 'path',
        value: nodedata.path,
        group: 'categoryGroup',
        operation: 'RIGHT_LIKE',
        relation: 'AND'
      }
      this.loadData(queryFilter, () => {})
    },
    close() {
      this.loadData()
      this.api = {
        actionType: '',
        alias: '',
        name: '',
        requestUrl: ''
      }
      this.dialogVisible = false
    },
    toSave() {
      let _this = this
      if (_this.api && _this.api.id) {
        portalApi.updateAction(this.api).then((rep) => {
          if (rep && rep.state) {
            _this.$message({ type: 'success', message: rep.message })
            _this.close()
          } else {
            _this.$message.error(rep.message)
          }
        })
      } else {
        portalApi.saveAction(this.api).then((rep) => {
          if (rep && rep.state) {
            _this.$message({ type: 'success', message: rep.message })
            _this.close()
          } else {
            _this.$message.error(rep.message)
          }
        })
      }
    },
    save() {
      if (!this.api.name) {
        this.$message({ message: '请填写名称！', type: 'warning' })
        return
      }
      if (!this.api.alias) {
        this.$message({ message: '请填写别名！', type: 'warning' })
        return
      }
      if (!this.api.actionType) {
        this.$message({
          message: '请选择请求方法名！',
          type: 'warning'
        })
        return
      }

      if (!this.api.requestUrl) {
        this.$message({ message: '请填写接口地址！', type: 'warning' })
        return
      }
      this.toSave()
    },
    beforeClose() {
      this.dialogVisible = false
    },
    loadData(param, cb) {
      if (this.pathQuery) {
        param.querys.push(this.pathQuery)
      }
      // 参数说明  url  requestBodyParam  requestParam
      req
        .post('${portal}/sys/sysAction/v1/query', param)
        .then((data) => {
          let response = data.data
          this.data = response.rows
          this.pagination = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .error-small {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 0;
  margin-top: 0;
  position: absolute;
  top: 80%;
  left: 0;
}
>>> .el-table td,
th {
  padding: 13px 0;
}

>>> .el-form-item__content {
  width: unset;
}

.form-empty {
  position: absolute;
  text-align: center;
  width: 300px;
  font-size: 20px;
  top: 200px;
  left: 50%;
  margin-left: -150px;
  color: #ccc;
}
</style>
